export default __webpack_public_path__ + "1d3557bc343368e10d4100105c6e4e53.svg";